import {ResourceManagerTask} from "@k/global/resourcemanager/task";

export default {
    state: () => (
        {
            tasks: [] as ResourceManagerTask[],
        }),
    getters: {
        taskExists:(state)=>taskname=>state.tasks.some(t=>t.taskName === taskname),
        getTasksThatMeetRequirements:(state, getters)=>state.tasks.filter(t=>getters.taskPrerequisitesMet(t)),
        getInvalidatedTasks:state=>eventName=>state.tasks.filter(t=>t.invalidatedWhen.includes(eventName)),
    },
    mutations: {
        deleteTask:(state, taskname)=>state.tasks = state.tasks.filter(t=>t.taskName !== taskname),
        addTask:(state, task:ResourceManagerTask)=>state.tasks.push(task),
    },
    actions: {
        checkTasksAndExecute(context) {

            const tasksThatMeetrequirements = context.getters.getTasksThatMeetRequirements;
            tasksThatMeetrequirements.map(t => {
                context.commit("deleteTask", t.taskName);
                t.execute(context.getters.getDataForTask(t));
            });
            if (tasksThatMeetrequirements.length > 0) {
                context.dispatch("checkTasksAndExecute");
            }
        },
        deleteInvalidatedTasks(context, eventName) {
            const invalid = context.getters.getInvalidatedTasks(eventName);
            invalid.forEach(t => context.commit("deleteTask", t.taskName))
        },
    },
}
